<template>
  <div :class="lange=='en'?'box_bain':'box_bain box_m_bain'">
    <span class="span_1">
      {{ lange == "ch" ? "艺识代知识产权思享会" : "EasyTimes IP Sharing Session" }}
    </span>
    <div class="mban-box">
         <div class="div_1" :style="{'width':lange == 'en'?'80%':'80%'}">{{
        lange == "ch"
          ? "为了关注、探讨和分享知识产权热点问题，邀请各界资深专业人士，助力北京经济技术（亦庄）开发区企业及广大客户与同仁提高知识产权意识与应用水平，艺识代知识产权将定期举办知识产权思享会。其活动方式为：每次活动确定一个主题，安排和邀请有关知识产权资深专业人士作主题发言和讨论，对该主题有兴趣或者疑问的人士可以到场听讲和讨论，咨询和交流，最终形成综述公开分享。"
          : "We invite senior professionals from all walks of life to follow, discuss and share ideas on hot issues of intellectual property, so as to help enterprises in Beijing Economic and Technological (Yizhuang) Development Area, clients and  colleagues to improve their intellectual property awareness and application level.We will hold EasyTimes IP Sharing Session periodically. The form of the sessions is as follows:"
      }}
    </div>
    <div class="div_1" :style="{'width':lange == 'en'?'80%':'80%'}">{{
        lange == "ch"
          ? ""
          : "Each session has its topic. We will invite senior professionals in relevant fields to make a presentation about the topic. If you are interested in or have questions about the topic, please feel free to join us for discussion and exchange opinions. Finally, we will share the minute of the session with the public."
      }}
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IPsixianghuiText",
  components: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
    };
  },
  methods:{
    preventScroll(event) {
      event.preventDefault(); // 阻止默认的滚动行为
    }
  },
  created() {
    //this.$cookies.setCookie("tops", "padding-top:70%;");
  },
  mounted() {
  },
  destroyed() {
    this.$cookies.removeCookie("tops");
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


@media screen and (min-width: 1151px) {
  .box_bain {
      width: 57%;
      height: 100%;
      position: absolute;
      top: 10%;
      right: -3%;
      overflow: hidden;
      text-align: center;
      display:table-cell;
      vertical-align:middle;
  }
}
@media screen and (min-width: 1514px) {
  .box_bain {
      top: 20%;
  }
}
.span_1 {
  display: inline-block;
  font-size: 26px;
  /* color: #c28e33; */
  position: relative;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  color: #bda67d;
/*  margin-top: 4%;
  right: -9%; */
  /* font-weight : bold; */
}
.span_1 > img {
  width: 30%;
  height: 2px;
  display: block;
  position: absolute;
  top: 50%;
}

@media screen and (min-width: 1151px) {
  .img_1 {
    left: 85px;
  }
}
@media screen and (max-width: 1150px) {
  .img_1 {
    left: 0;
  }
}
@media screen and (min-width: 1151px) {
  .img_2 {
    right: 85px;
  }
}
@media screen and (max-width: 1151px) {
  .img_2 {
    right: 0px;
  }
}
.div_1 {
    width: 80%;
    display: block;
    font-size: 18px;
    color: #fff;
    margin: 0 auto;
    padding-top:20px;
    text-align: left;
}
@media only screen and (max-width: 1440px) {
  .div_1 {
      width: 80% !important;
      display: block;
      font-size: 18px;
      margin: 0 auto;
      padding-top: 30px;
  }
  .span_1 {
    margin-top:2%;
  }
}
@media only screen and (max-width: 1024px) {
  .div_1 {
    font-size: 14px;
    padding-top: 5px;
  }
}
@media only screen and (max-width: 768px) {
  .span_1 {
    display: inline-block;
    position: relative;
    /* padding: 0% 23%; */
    margin-top: 7%;
    right:0;
  }
}
@media only screen and (max-width: 600px) {
  .div_1 {
    font-size: 12px;
  }
}
@media only screen and (max-width: 425px) {
  .div_1 {
    font-size: 10px;
  }
  .mban-box{
    padding-top: 5px;
    max-height: 170px;
    overflow-y: scroll;
  }
  .span_1 {
    font-size: 18px;
  }
  .box_bain {
    height: auto;
    /* top:52% !important; */
    left: 0;
    margin-top: -90px;
  }
  .box_m_bain{
    top:52% !important;
  }
}
@media only screen and (max-width: 800px) {
  .box_bain {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 80px;
    left: 0;
    overflow: hidden;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner/component/IPsixianghuiText.vue